// extracted by mini-css-extract-plugin
export default {"loadingActionMessage":"loadingActionMessage-g60y2"};